import { createReducer, on } from "@ngrx/store";
import { Bill } from "../../models/bill.model";
import { billActions } from "./bill.actions";

export interface BillState {
    bills: Bill[]|null,
    state: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: BillState = {
    bills: null,
    state: 'pending'
};

export const billReducer = createReducer(
    initialState,
    on(billActions.loadBills, (state) => ({
        ...state,
        bills: null,
        state: "loading" as const
    })),
    on(billActions.loadBillsSuccess, (state, {payload}) => ({
        ...state,
        bills: payload,
        state: "loaded" as const
    })),
    // on(billActions.addBillSuccess, (state, {payload}) => state.concat(payload)),
    on(billActions.deleteBillSuccess, (state, {payload}) => ({
        ...state,
        bills: state.bills!.filter((bill) => !payload.includes(bill.bill_id)),
        state: 'loaded' as const
    })),
    on(billActions.loadBillsFail, (state) => ({
        bills: null,
        state: 'error' as const
    })),
    on(billActions.clearBills, (state) => initialState),
)